import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; Thank You for Visiting</p>
    </footer>
  );
};

export default Footer;